module.exports = __webpack_public_path__ + "img/13.a30c8a17.jpg";